/**
 * @param {string} target
 * @param {object} options
 */
function appendScript (target, options) {
  if (!target || !options || typeof window === 'undefined') return

  const src = options?.src
  const type = options?.type || 'text/javascript'
  const async = options?.async || false

  if (!src) return
  if (document.querySelector(`script[src="${src}"]`)) return

  const el = document.createElement('script')
  el.setAttribute('type', type)
  el.async = async
  el.src = src

  setTimeout(() => {
    const targetEl = document.getElementById(target)
    targetEl?.appendChild(el)
  }, 500)
}

module.exports = { appendScript }
